import { thenModalPath } from 'components/block/Then/Then.paths'
import { AppRoute } from 'components/components.types'
import { BindingSocialAccountLoadable } from 'components/page/BindingSocialAccount/BindingSocialAccountLoadable'
import {
  cityListPath,
  loginPath,
  loginVariantsPath,
  otherSocialNetworksPath,
  shortcutListPath,
} from 'components/page/Boarding/boarding.paths'
import { CityListLoadable } from 'components/page/Boarding/CityListLoadable'
import { LoginLoadable } from 'components/page/Boarding/LoginLoadable'
import { LoginVariantsLoadable } from 'components/page/Boarding/LoginVariantsLoadable'
import { LoginVariantsWithEmail } from 'components/page/Boarding/LoginVariantsWithEmail'
import { RegistrationLoadable } from 'components/page/Boarding/RegistrationLoadable'
import { ShortcutListLoadable } from 'components/page/Boarding/ShortcutListLoadable'
import {
  unauthorizedCaptchaPath,
  unauthorizedCaptchaReasonsPath,
} from 'components/page/Captcha/Captcha.paths'
import { CaptchaPageLoadable } from 'components/page/Captcha/CaptchaPageLoadable'
import { CaptchaReasonListLoadable } from 'components/page/Captcha/CaptchaReasonListLoadable'
import { DiamondsModalLoadable } from 'components/page/DiamondsInfo/DiamondsModalLoadable'
import { promoCodeRoutes } from 'components/page/PromoCode/promoCode.routes'
import {
  socialAuthorizationFailFullPath,
  socialAuthorizationSuccessPath,
} from 'components/page/SocialAuthorization/socialAuthorization.paths'
import { SocialAuthorizationFailLoadable } from 'components/page/SocialAuthorization/SocialAuthorizationFailLoadable'
import { SocialAuthorizationSuccessLoadable } from 'components/page/SocialAuthorization/SocialAuthorizationSuccessLoadable'
import {
  finalStepPath,
  stepRegistrationStepPath,
} from 'components/page/StepRegistration/StepRegistration.paths'
import {
  boundSocialAccountPath,
  diamondsPath,
  enterEmailPath,
  logoutPath,
  registrationPath,
  settingsModalPath,
} from 'components/paths'
import { FoundComponent } from 'components/system/FoundComponent'
import { UnauthorizedRedirect } from 'components/system/UnauthorizedRedirect'
import { mergeAllUrls } from 'functions/mergeAllUrls'

const unauthorizedModalRoutes: AppRoute[] = [
  {
    path: mergeAllUrls(loginPath, thenModalPath),
    component: LoginLoadable,
    shouldCheck: true,
  },
  {
    path: loginPath,
    component: LoginLoadable,
  },
  {
    /**
     * Урл не совсем корректный, но это не столь важно, потому что:
     * 1. Важно поправить 404
     * 2. Функционал отложенного действия не работает при авторизации через вендора
     * 3. Функционал отложенного действия будет переработан
     */
    path: mergeAllUrls(
      loginPath,
      thenModalPath,
      otherSocialNetworksPath,
      ':limit'
    ),
    component: LoginVariantsLoadable,
  },
  {
    path: mergeAllUrls(loginPath, otherSocialNetworksPath, ':limit'),
    component: LoginVariantsLoadable,
  },
  {
    path: loginVariantsPath,
    component: LoginVariantsWithEmail,
  },
  {
    path: mergeAllUrls(registrationPath, thenModalPath),
    component: RegistrationLoadable,
  },
  { path: registrationPath, component: RegistrationLoadable },
  { path: enterEmailPath, component: () => null },
  ...promoCodeRoutes,
  {
    path: mergeAllUrls(otherSocialNetworksPath, ':limit'),
    component: LoginVariantsLoadable,
  },
  {
    path: mergeAllUrls(finalStepPath, otherSocialNetworksPath, ':limit'),
    component: LoginVariantsLoadable,
  },
  {
    path: socialAuthorizationFailFullPath,
    component: SocialAuthorizationFailLoadable,
  },
  {
    path: socialAuthorizationSuccessPath,
    component: SocialAuthorizationSuccessLoadable,
  },
  { path: unauthorizedCaptchaPath, component: CaptchaPageLoadable },
  {
    path: unauthorizedCaptchaReasonsPath,
    component: CaptchaReasonListLoadable,
  },
  { path: cityListPath, component: CityListLoadable },
  {
    path: shortcutListPath,
    component: ShortcutListLoadable,
  },
  {
    path: boundSocialAccountPath,
    component: BindingSocialAccountLoadable,
  },
  {
    path: diamondsPath,
    component: DiamondsModalLoadable,
  },
  {
    path: stepRegistrationStepPath,
    component: FoundComponent,
  },
  {
    path: logoutPath,
    component: UnauthorizedRedirect,
  },
  {
    path: settingsModalPath,
    component: UnauthorizedRedirect,
    skip: true,
  },
]

export default unauthorizedModalRoutes
